export default function ImageGalleryItem({
  smallImage,
  largeImage,
  onClick,
}) {
  return (
    <li className="ImageGalleryItem">
      <img
        className="ImageGalleryItem-image"
        src={smallImage}
        alt=""
        onClick={() => onClick(largeImage)}
      />
    </li>
  );
}
